import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { check } from '@primeicons/core/check';

@Component({
    selector: 'svg[data-p-icon="check"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class Check extends CoreIcon {
    constructor() {
        super();
        this._icon = check;
    }
}
